import * as React from 'react'
import * as API from '../lib/api'
import { CreditCardForm } from './CreditCardForm'
import { PaymentProfileForm } from './PaymentProfileForm'
import { PaymentTokenForm } from './PaymentTokenForm';

interface IProps {
  creditCard?: API.ICreditCard
  paymentProfiles: API.IPaymentProfile[]
  selectedPaymentProfileId?: number
  paymentType: string
  children?: React.ReactNode
  paymentToken?: API.IPaymentToken
  paymentTokenErrors?: API.IAuthErrors
}

interface IState {
  addCard: boolean
}

export class PaymentForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)

    const { paymentProfiles, paymentType } = this.props
    const addCard = paymentType === 'credit_card' || paymentProfiles.length === 0

    this.state = {
      addCard,
    }
  }

  public handleAddNewCardClick = () => {
    this.setState({
      addCard: true,
    })
  }

  public handleCancelAddNewCardClick = () => {
    this.setState({
      addCard: false,
    })
  }

  public render() {
    const {
      children,
    } = this.props

    return (
      <section className="payment-information">
        <h2>Payment Information</h2>
        {children}
        {this.renderForms()}
      </section>
    )
  }

  private renderForms() {
    const {
      paymentProfiles,
      selectedPaymentProfileId,
      creditCard,
      paymentToken,
    } = this.props
    const { addCard } = this.state

    if (addCard) {
      if (paymentToken) {
        return (
          <PaymentTokenForm {...paymentToken} />
        )
      } else {
        return (
          <CreditCardForm
            creditCard={creditCard}
            handleCancelAddNewCardClick={this.handleCancelAddNewCardClick}
            allowCancelling={paymentProfiles.length > 0}
          />
        )
      }
    } else {
      return (
        <PaymentProfileForm
          selectedProfileId={selectedPaymentProfileId}
          paymentProfiles={paymentProfiles}
          handleAddNewCardClick={this.handleAddNewCardClick}
        />
      )
    }

  }
}
